import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export default function EmptyState({
  title = "Нет данных",
  hint,
  action,
  compact,
  className,
}: {
  title?: string;
  hint?: string;
  action?: React.ReactNode;
  // Без карточки и крупной иконки — для пустого блока ВНУТРИ уже
  // нарисованной card (вторая рамка вокруг «нет данных» выглядит как баг).
  compact?: boolean;
  className?: string;
}) {
  if (compact) {
    return (
      <div
        className={cn(
          "flex items-center justify-center gap-2 px-3 py-6 text-center text-sm text-ink-500 dark:text-ink-400",
          className,
        )}
      >
        <Inbox className="h-4 w-4 shrink-0 text-ink-400" />
        <span>
          {title}
          {hint && <span className="text-ink-400"> — {hint}</span>}
        </span>
        {action}
      </div>
    );
  }
  return (
    <div
      className={cn(
        "card p-10 flex flex-col items-center justify-center text-center gap-3",
        className,
      )}
    >
      <div className="h-12 w-12 rounded-2xl bg-ink-100 dark:bg-ink-800 grid place-items-center text-ink-500">
        <Inbox className="h-6 w-6" />
      </div>
      <div className="font-semibold">{title}</div>
      {hint && (
        <div className="text-sm text-ink-500 dark:text-ink-400 max-w-md">
          {hint}
        </div>
      )}
      {action}
    </div>
  );
}
